module.exports = __webpack_public_path__ + "img/icon-package-price-light.4132c40.svg";